/**
 * Represents location geocoding information
 */
export interface GeocodeResponse {
    /**
     * Unique identifier for the place
     */
    placeId: string;

    /**
     * Type of the place
     */
    placeType: PlaceType;

    /**
     * Title or name of the place
     */
    title: string;

    /**
     * Position as [latitude, longitude]
     */
    position: number[];

    /**
     * Locality (nullable)
     */
    locality: string | null;

    /**
     * Sub-region (nullable)
     */
    subRegion: string | null;

    /**
     * Region (nullable)
     */
    region: string | null;

    /**
     * Country (nullable)
     */
    country: string | null;

    /**
     * Derived locality name which composed as follows:
     * <locality>, <region>, <country>
     */
    localityName: string | null;

    /**
     * Derived region name which composed as follows:
     * <locality>, <region>, <country>
     */
    regionName: string | null;
}

/**
 * Enum for place types
 */
export enum PlaceType {
    Country = 'Country',
    Region = 'Region',
    SubRegion = 'SubRegion',
    Locality = 'Locality',
    District = 'District',
    SubDistrict = 'SubDistrict',
    PostalCode = 'PostalCode',
    Block = 'Block',
    SubBlock = 'SubBlock',
    Intersection = 'Intersection',
    Street = 'Street',
    PointOfInterest = 'PointOfInterest',
    PointAddress = 'PointAddress',
    InterpolatedAddress = 'InterpolatedAddress',
    SecondaryAddress = 'SecondaryAddress',
}
